<template>
  <div class="personal-center">
    <!-- 个人信息卡片 -->
    <el-card class="user-info-card">
      <div class="user-header">
        <el-avatar :size="80" :src="require('@/assets/avatar-default.png')"></el-avatar>
        <div class="user-meta">
          <h2>{{ userInfo.nickname }}</h2>
          <p class="email">{{ userInfo.phonenumber }}</p>
          <p class="register-time">注册时间：{{ userInfo.createTime }}</p>
        </div>
      </div>
    </el-card>

    <!-- API凭证管理 -->
    <el-card class="api-credentials">
      <div slot="header" class="clearfix">
        <span>开放服务</span>
        <el-button
          v-if="!appInfo.appKey"
          type="primary"
          size="small"
          @click="handleApply"
          style="float: right;">
          生成AppKey
        </el-button>
      </div>

      <!-- 已生成凭证展示 -->
      <div v-if="appInfo.appKey" class="credentials-display">
        <el-alert
          title="请妥善保管以下凭证信息"
          type="warning"
          :closable="false"
          show-icon>
        </el-alert>

        <div class="credential-item">
          <label>App Key:</label>
          <el-tag type="info" class="credential-value">{{ appInfo.appKey }}</el-tag>
          <el-button
            size="mini"
            icon="el-icon-document-copy"
            ref="copyAppKeyBtn"
            @click="copyText(appInfo.appKey)"
          >
          </el-button>
        </div>

        <div class="credential-item">
          <label>App Secret:</label>
          <el-tag type="danger" class="credential-value">{{ appInfo.appSecretKeyShow }}</el-tag>
          <el-button
            size="mini"
            icon="el-icon-view"
            ref="copyAppSecretBtn"
            :data-clipboard-text="appInfo.appSecret"
            @click="changeShowSecret"
          >
          </el-button>
          <el-button
            size="mini"
            icon="el-icon-document-copy"
            ref="copyAppSecretBtn"
            :data-clipboard-text="appInfo.appSecret"
            @click="copyText(appInfo.appSecret)"
          >
          </el-button>
        </div>
      </div>

      <!-- 空状态提示 -->
      <el-empty v-else description="尚未生成任何凭证"></el-empty>
    </el-card>

  </div>
</template>

<script>

import {generateUserSecretKey, getDecryptKey, getUser, getUserSecretKey} from "@/api/system/user"
import CryptoJS from 'crypto-js'

export default {
  name: "UserInfo",
  data() {
    return {
      userInfo: {},
      appInfo: {}
    }
  },
  mounted() {
    this.getUserInfo()
  },
  methods: {
    changeShowSecret() {
      if (this.appInfo.appSecret === this.appInfo.appSecretKeyShow) {
        this.appInfo.appSecretKeyShow = "**********************************"
      } else {
        this.appInfo.appSecretKeyShow = this.appInfo.appSecret
      }
    },
    copyText(text) {
      this.$copyText(text).then(() => {
        this.$message.success("复制成功")
      }).catch(() => {
        this.$message.error("复制失败")
      })
    },
    getUserInfo() {
      getUser(this.$store.state.user.id).then(response => {
        this.userInfo = response.data
      })
      getUserSecretKey(this.$store.state.user.id)
        .then(response => {
          getDecryptKey(response.data.notifyStr).then(resp => {
            const [key, iv] = resp.data.split("===")
            this.appInfo = {
              ...response.data,
              appSecret: this.decrypt(response.data.appSecret, key, iv),
              appSecretKeyShow: "**********************************",
              isShowSecret: false
            }

          })


        })
    },
    // 处理申请
    handleApply() {
      generateUserSecretKey(this.$store.state.user.id).then(response => {
        if (response.code === 200) {
          this.appInfo = {
            ...response.data,
            appSecretKeyShow: "**********************************",
            isShowSecret: false
          }
          this.$message.success('凭证生成成功')
        } else {
          this.$message.error(response.msg)
        }
      }).catch((e) => this.$message.error(e))
    },

    decrypt(encryptedBase64, key, iv) {
      const encryptedData = CryptoJS.enc.Base64.parse(encryptedBase64)
      const keyBytes = CryptoJS.enc.Utf8.parse(key)
      const ivBytes = CryptoJS.enc.Utf8.parse(iv)
      const decryptOptions = {
        iv: ivBytes,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
      const decrypted = CryptoJS.AES.decrypt(
        {ciphertext: encryptedData},
        keyBytes,
        decryptOptions
      )
      return decrypted.toString(CryptoJS.enc.Utf8)
    }
  }
}
</script>

<style lang="scss" scoped>
.personal-center {
  max-width: 1000px;
  margin: 20px auto;
  padding: 20px;

  .user-info-card {
    margin-bottom: 20px;

    .user-header {
      display: flex;
      align-items: center;

      .user-meta {
        margin-left: 30px;

        h2 {
          margin: 0 0 8px 0;
          color: #303133;
        }

        .email {
          color: #606266;
          margin: 8px 0;
        }

        .register-time {
          color: #909399;
          font-size: 12px;
        }
      }
    }
  }

  .api-credentials {
    .credentials-display {
      .credential-item {
        margin: 20px 0;
        display: flex;
        align-items: center;

        label {
          width: 100px;
          color: #606266;
        }

        .credential-value {
          margin: 0 10px;
          flex: 1;
          font-family: monospace;
        }
      }

      .generate-time {
        color: #909399;
        font-size: 12px;
        text-align: right;
      }
    }
  }

  .el-alert {
    margin-bottom: 20px;
  }
}

// 响应式适配
@media (max-width: 768px) {
  .personal-center {
    padding: 10px;

    .user-header {
      flex-direction: column;
      text-align: center;

      .user-meta {
        margin-left: 0 !important;
        margin-top: 15px;
      }
    }

    .el-dialog {
      width: 90% !important;
    }
  }
}
</style>
